<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Judul" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Judul
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. SURAT PAKLARING"
            hide-details

            v-model="form.template_meta_json_object.judul"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Judul {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.judul !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="No." 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            No.
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 005/PT.UMB/IV/2022"
            hide-details

            v-model="form.template_meta_json_object.nomor"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  No. {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Lampiran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Lampiran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 1 Lembar"
            hide-details

            v-model="form.template_meta_json_object.lampiran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 50%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Lampiran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal"
                  :success="form.template_meta_json_object.tanggal !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal"
              @input="picker.tanggal = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Nama Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
            hide-details

            v-model="form.template_meta_json_object.nama_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Jabatan Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Jabatan Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Direktur Utama PT.UMB."
            hide-details

            v-model="form.template_meta_json_object.jabatan_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Jabatan Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Nama Yang Bersangkutan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Yang Bersangkutan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Wildan Faizal Imawan"
            hide-details

            v-model="form.template_meta_json_object.nama_2"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Yang Bersangkutan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_2 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Jabatan Yang Bersangkutan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Jabatan Yang Bersangkutan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Programer"
            hide-details

            v-model="form.template_meta_json_object.jabatan_2"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Jabatan Yang Bersangkutan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.jabatan_2 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Alamat Yang Bersangkutan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Alamat Yang Bersangkutan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-textarea
            filled
            rounded
            dense
            :color="set_color"

            rows="3"
            
            placeholder="Contoh. Dusun Mlaten RT 003 RW 003 Gadingmangu, Perak, Jombang, Jawa Timur"
            hide-details

            v-model="form.template_meta_json_object.alamat_2"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Alamat Yang Bersangkutan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.alamat_2 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-textarea>
        </ValidationProvider>

        <ValidationProvider
          name="Unit" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Unit
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-autocomplete
            filled
            rounded
            dense
            :color="set_color"
            hide-details
            placeholder="Contoh. UMB Boga"

            :loading="process.unit"
            
            :items="units"
            item-value="name"
            item-text="name"
            :item-color="set_color"

            v-model="form.template_meta_json_object.unit"
            :success="form.template_meta_json_object.unit !== '' && valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Unit {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.unit !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </ValidationProvider>

        <v-row>
          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Masuk
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_masuk"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_mulai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Masuk" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Contoh. 2022-12-30"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_mulai = null; form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_mulai"
                      :success="form.template_meta_json_object.tanggal_mulai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Masuk {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_mulai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  v-model="form.template_meta_json_object.tanggal_mulai"
                  @input="picker.tanggal_mulai = false; form.template_meta_json_object.tanggal_selesai = null;">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>

          <v-col
            cols="12"
            md="5"
            class="py-0">
            <div>
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tanggal Keluar
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>

              <v-menu
                ref="tanggal_keluar"
                min-width="290px"
                max-width="290px"
                transition="scale-transition"
                offset-y
                :nudge-right="40"
                :close-on-content-click="false"
                v-model="picker.tanggal_selesai">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider 
                    name="Tanggal Keluar" 
                    rules="required"
                    v-slot="{ errors, valid }">
                    <v-text-field
                      readonly
                      filled
                      rounded
                      dense
                      :color="set_color"
                      placeholder="Pilih Tanggal"
                      hide-details
                      clearable

                      @click:clear="form.template_meta_json_object.tanggal_selesai = null;"
                      v-on="on"
                      v-bind="attrs"

                      v-model="form.template_meta_json_object.tanggal_selesai"
                      :success="form.template_meta_json_object.tanggal_selesai !== null && valid"
                      :error-messages="errors"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tanggal Keluar {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.template_meta_json_object.tanggal_selesai !== null && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </template>

                <v-date-picker 
                  :color="set_color"
                  :min="form.template_meta_json_object.tanggal_mulai"
                  v-model="form.template_meta_json_object.tanggal_selesai"
                  @input="picker.tanggal_selesai = false">
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
        </v-row>

        <ValidationProvider 
          name="Alasan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Alasan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-textarea
            filled
            rounded
            dense
            :color="set_color"

            rows="3"
            
            placeholder="Contoh. diterima bekerja di perusahaan lain"
            hide-details

            v-model="form.template_meta_json_object.alasan"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-3"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Alasan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.alasan !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-textarea>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-title
              class="d-flex justify-center black--text text-uppercase mb-4"
              style="text-transform: uppercase !important; margin-bottom: 16px !important; display: flex !important; justify-content: center !important; font-size: 1.25rem; font-weight: 500; line-height: 2rem; padding: 16px ">
              {{ form.template_meta_json_object.judul }}
            </v-card-title>

            <v-card-text
              class="black--text">
              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      No.
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Hal
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.judul !== '' ? form.template_meta_json_object.judul : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Lampiran
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  cols="12"
                  md="5">
                  <div
                    class="text-right"
                    style="text-align: right !important;">
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>
                </v-col>
              </v-row>

              <div
                class="mt-6"
                style="margin-top: 24px !important;">
                <div
                  class="mb-2"
                  style="margin-bottom: 8px !important;">
                  Yang bertandatangan di bawah ini:
                </div>

                <div
                  class="px-8"
                  style="padding-right: 32px !important; padding-left: 32px !important;">
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nama
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Jabatan
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div
                class="mt-2"
                style="margin-top: 8px !important;">
                <div
                  class="mb-2"
                  style="margin-bottom: 8px !important;">
                  Dengan ini menerangkan bahwa yang bersangkutan di bawah ini:
                </div>

                <div
                  class="px-8"
                  style="padding-right: 32px !important; padding-left: 32px !important;">
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nama
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Alamat
                    </v-col>

                    <v-col
                      cols="12"
                      md="10"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      <div
                        class="d-flex align-start"
                        style="display: flex !important; align-items: flex-start !important;">
                        <div>
                          :
                        </div>

                        <div
                          class="ml-1"
                          style="margin-left: 4px !important;">
                          {{ form.template_meta_json_object.alamat_2 !== '' ? form.template_meta_json_object.alamat_2 : '__________' }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>

              <div
                class="mt-8"
                style="margin-top: 32px !important;">
                <div
                  class="mb-2"
                  style="margin-bottom: 8px !important;">
                  Karyawan tersebut benar telah bekerja di {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }} sejak
                  <span v-if="form.template_meta_json_object.tanggal_mulai !== '' && form.template_meta_json_object.tanggal_mulai !== null">
                    {{ form.template_meta_json_object.tanggal_mulai | fulldate }} 
                  </span>

                  <span v-else>
                    __________
                  </span>
                  sampai dengan
                  <span v-if="form.template_meta_json_object.tanggal_selesai !== '' && form.template_meta_json_object.tanggal_selesai !== null">
                    {{ form.template_meta_json_object.tanggal_selesai | fulldate }} 
                  </span>

                  <span v-else>
                    __________
                  </span>
                  Adapun jabatan terakhir saudara adalah sebagai {{ form.template_meta_json_object.jabatan_2 !== '' ? form.template_meta_json_object.jabatan_2 : '__________' }}.
                </div>

                <div
                  class="mb-2"
                  style="margin-bottom: 8px !important;">
                  Selama bekerja di {{ form.template_meta_json_object.unit !== '' ? form.template_meta_json_object.unit : '__________' }}, Saudara telah memberikan dedikasi dan loyalitasnya yang besar terhadap perusahaan serta tak pernah sekalipun melakukan hal – hal yang merugikan perusahaan. Dalam hal ini saudara {{ form.template_meta_json_object.nama_2 !== '' ? form.template_meta_json_object.nama_2 : '__________' }} mengundurkan diri karena {{ form.template_meta_json_object.alasan !== '' ? form.template_meta_json_object.alasan : '__________' }}.
                </div>

                <div
                  class="mb-2"
                  style="margin-bottom: 8px !important;">
                  Kami sangat berterimakasih atas kerja kerasnya selama ini dan mengharapkan saudara dapat sukses pada masa mendatang.
                </div>

                <div>
                  Demikian surat paklaring ini kami buat agar dapat dipergunakan dengan semestinya. Atas perhatiannya, kami ucapkan terimakasih.
                </div>

                <v-row
                  justify="end"
                  class="mt-8"
                  style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                  <v-col
                    cols="12"
                    md="6"
                    class="text-center"
                    style="text-align: center !important;">
                    <div>
                      Hormat Kami,
                    </div>

                    <div
                      class="mb-16"
                      style="margin-bottom: 64px !important;">
                      {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                    </div>

                    <div>
                      {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {

    }
  }
</script>
